<template>
  <div>
    <BlogEditorSettings v-model="modelBlog"/>
    <BlogEditorSettingsWords v-model="modelBlog"/>
    <BlogEditorSettingsActions v-model="modelBlog"/>
    <BlogEditorSettingsFiles v-model="modelBlog"/>
  </div>
</template>

<script setup lang="ts">
const modelBlog = defineModel<Blog | any>('blog')
</script>
